// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { Grid } from '@mui/material';
import { withStyles } from "tss-react/mui";
import CloseIcon from '@mui/icons-material/Close';

import { getTestAttr } from '@shared/utils/common';

export interface FormHeaderProps {
  className?: string;
  classes?: Record<string, string>;
  closeComponent?: JSX.Element | null;
  moduleName: string;
  heading: React.ReactNode;
  onClose: () => any;
}

const FormHeader: React.FC<FormHeaderProps> = (props: FormHeaderProps) => {
  const { closeComponent = (<><span>Close</span><CloseIcon /></>), moduleName, heading, onClose } = props;
  const classes = withStyles.getClasses(props);

  return (
    <Grid container alignItems="flex-end" justifyContent="space-between" wrap='nowrap' className={classes.root}>
      <h6 className={classes.heading}>{heading}</h6>
      <div
        {...getTestAttr(moduleName, 'form-close', 'div')}
        className={classes.closeElement}
        onClick={onClose}
      >
        {closeComponent}
      </div>
      {/* <Grid
        container
        {...getTestAttr(moduleName, 'form-close', 'div')}
        alignItems="flex-end"
        className={classes.closeElement}
        onClick={onClose}
      >
        {closeComponent}
      </Grid> */}
    </Grid>
  );
};

// FormHeader.defaultProps = {
//   closeComponent: (
//     <>
//       <span>Close</span>
//       <CloseIcon />
//     </>
//   ),
// };

const FormHeaderStyled = withStyles(
  FormHeader, 
  (theme, props) => ({
    "root": {
      padding: theme.spacing(6),
      boxShadow: `0px 2px 4px rgba(0, 0, 0, 0.08)`,
    },
    "heading": {
      fontWeight: 500,
      fontSize: 20,
      color: theme.palette.colors.black,
      width: '75%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    "closeElement": {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap' as const,
      color: theme.palette.colors.primaryAccent,
      width: 'auto',
      fontWeight: 500,
      cursor: 'pointer',
      fontSize: 20,
      
      '&:hover': {
        opacity: .6
      },
      
      '& *': {
        fontSize: 'inherit',
      },
      
      '& span': {
        lineHeight: 1,
        marginRight: theme.spacing(1)
      }
    }
  })
);

export default FormHeaderStyled;